import {Pipe, PipeTransform} from '@angular/core';
import {ICruiseDetailCabin} from '../../cruise-detail-page/interfaces/icruise-detail-cabin';
import {IShipServiceRemote} from '../../cruise-detail-page/interfaces/iship-service-remote';

@Pipe({
  name: 'allCabinInfoByTypeFromShipservice'
})
export class AllCabinInfoByTypeFromShipservicePipe implements PipeTransform {

  transform(value: ICruiseDetailCabin, shipService: IShipServiceRemote): {description: string, subtitle: string, surface: string, typology: string} {
    // se ho passato il dettaglio cabina e lo shipService ...
    if (value && shipService) {
      // recupero la cabina con type specifico
      const cabin = shipService.cabins?.find((cab) => cab.category.toLowerCase() === value.type.toLowerCase());

      // ritorno un oggetto contenente alcune info cabina ("description", "subtitle" e "surface")
      // NB: è possibile aggiungere altre info a patto che si modifichi pure l'interfaccia
      return {
        description: cabin.description || '<i>Nessuna descrizione presente</i>',
        subtitle: cabin.subtitle,
        surface: cabin.surface,
        typology: cabin.typology
      };
    }

    // se non è stato passato alcun dettaglio cabina e lo shipservice, ritorno un oggetto con le info cabina non presenti
    return {description: '<i>Nessuna descrizione presente</i>', subtitle: '', surface: '', typology: ''};
  }

}
